import { ErrorHandler, Injectable } from '@angular/core';

interface NewRelicBrowser {
  noticeError(error: Error, customAttributes?: Record<string, unknown>): void;
}

declare global {
  interface Window {
    newrelic?: NewRelicBrowser;
    angularPlatformRef?: unknown;
    ENV_TYPE?: string;
  }
}

type EnvType = 'prod' | 'homolog' | 'localhost';

const ANGULAR_VERSION = '17';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    const err = error instanceof Error ? error : new Error(String(error));

    const context: Record<string, unknown> = {
      route: this.getCurrentRoute(),
      angularVersion: ANGULAR_VERSION,
    };

    const env = this.getEnvType();

    if (env !== 'prod') {
      console.error('[GlobalErrorHandler]', err, context);
    }

    if (env === 'prod' && typeof window.newrelic?.noticeError === 'function') {
      try {
        window.newrelic.noticeError(err, context);
      } catch (reportError) {
        console.error('[GlobalErrorHandler] Falha ao reportar ao New Relic', reportError);
      }
    }
  }

  private getCurrentRoute(): string {
    try {
      return window.location.pathname + window.location.search;
    } catch {
      return 'unknown';
    }
  }

  private getEnvType(): EnvType {
    const env = window.ENV_TYPE;
    if (env === 'prod' || env === 'homolog' || env === 'localhost') {
      return env;
    }

    const host = window.location?.hostname ?? '';
    if (host.includes('localhost')) return 'localhost';
    if (host.includes('homolog')) return 'homolog';
    return 'prod';
  }
}
